var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "#FD1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.644101 30.6441C0.644101 14.0745 14.0745 0.644101 30.6441 0.644101C38.765 0.644101 46.1286 3.87041 51.5309 9.11315C46.0793 3.49323 38.4487 0 30 0C13.4315 0 0 13.4315 0 30C0 38.4487 3.49323 46.0793 9.11315 51.5309C3.87331 46.1286 0.644101 38.765 0.644101 30.6441Z",
    fill: "#FDF0F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1987 44.4255L32.0314 59.9217C47.0952 58.912 59.1126 46.793 59.9511 31.6828L44.1329 15.8646L16.1987 44.4255Z",
    fill: "url(#paint0_linear_371_4465)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5043 45.2263C17.5498 45.2263 16.5953 44.8607 15.867 44.1325C14.4105 42.676 14.4105 40.3143 15.867 38.8578L38.8573 15.8675C40.3138 14.411 42.6755 14.411 44.132 15.8675C45.5885 17.324 45.5885 19.6857 44.132 21.1422L21.1417 44.1325C20.4134 44.8607 19.4589 45.2263 18.5043 45.2263Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4947 45.2263C40.5401 45.2263 39.5856 44.8607 38.8573 44.1325L15.867 21.1422C14.4105 19.6857 14.4105 17.324 15.867 15.8675C17.3235 14.411 19.6852 14.411 21.1417 15.8675L44.132 38.8578C45.5885 40.3143 45.5885 42.676 44.132 44.1325C43.4038 44.8607 42.4492 45.2263 41.4947 45.2263Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_371_4465",
    x1: 26.5712,
    y1: 26.5517,
    x2: 51.2601,
    y2: 51.2406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8002C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.7129aeccac5b4c049d3d579aa436594a.svg";
export { ForwardRef as ReactComponent };